module.exports = __webpack_public_path__ + "fonts/iconfont.7daf2b2e.eot";